import { render, staticRenderFns } from "./OrdersPerPage.vue?vue&type=template&id=7f219b2e"
import script from "./OrdersPerPage.vue?vue&type=script&lang=js"
export * from "./OrdersPerPage.vue?vue&type=script&lang=js"
import style0 from "./OrdersPerPage.vue?vue&type=style&index=0&id=7f219b2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports